import { restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import { dividendEventMounted, getDividendEvent, updateDividendEvent } from "../model";
import { GetDividendAccrualsResponse } from "./types";

export const getDividendAccrualsByDividendEventId = fx<void, GetDividendAccrualsResponse>({
  method: 'GET',
  url: `/nova/dividend_accruals/id`,
})

export const $dividendAccruals = restore<GetDividendAccrualsResponse>(
  getDividendAccrualsByDividendEventId.doneData.map((a:any) => a.body),
  {userDividendAccruals: [], walletDividendAccruals: []},
)

// export const $dividendAccrualsUsers = restore<Record<string, Client>>({})

sample({
  clock: dividendEventMounted,
  fn: () => {
    return {userDividendAccruals: [], walletDividendAccruals: []}
  },
  target: $dividendAccruals,
})

sample({
  clock: [getDividendEvent.doneData, updateDividendEvent.doneData],
  fn: (doneData) => ({
    url: `/nova/dividend_accruals/${doneData.body.dividendEventID}`,
  }),
  target: [getDividendAccrualsByDividendEventId],
})
